import {
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '@core/auth';
import { environment } from '@env/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService) {}

    intercept(req: HttpRequest<unknown>, next: HttpHandler) {
        const token = this.authService.getToken();
        const isTrustedUrl = req.url.startsWith(environment.apiUrl);
        let request: HttpRequest<unknown> = req;

        if (token && isTrustedUrl) {
            request = req.clone({
                withCredentials: false,
                headers: req.headers.set('Authorization', `Bearer ${token}`),
            });
        }

        return next.handle(request);
    }
}
